export default __webpack_public_path__ + "static/media/rug9-min.24d8e541.jpg";